<script>
    import SmartTable from "Components/SmartTable";
    export default {
        extends: SmartTable,
        data: () => ({
            title: 'Roluri',
            dialog: false,
            dialogDelete: false,
            headers: [
                { text: 'Denumire', value: 'display_name' },
                { text: 'Numar utilizatori', value: 'users_count' },
                { text: 'Data crearii', value: 'created_at' },
                { text: 'Actiuni', value: 'actions', sortable: false },
            ],
            items: [],
            editedIndex: -1,
            editedItem: {},
            defaultItem: {},
            protectedRoles: []
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Adaugare' : 'Modificare'
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
        },

        async created () {
            await this.initialize()
        },

        methods: {
            async initialize () {
                this.protectedRoles = (new this.$db.Role).protectedRoles;
                let { data, meta } = await this.$db.Role
                    .orderBy(this.orderBy)
                    .include('usersCount')
                    .page(this.options.page)
                    .limit(this.options.itemsPerPage)
                    .params({
                        query: this.search
                    })
                    .get()
                this.items = data
                this.meta = meta
            },

            editItem (item) {
                this.$router.push({ name: 'admin-role-edit', params: { id: item.id } })
            },

            deleteItem (item) {
                this.editedIndex = this.items.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialogDelete = true
            },

            async deleteItemConfirm () {
                let item = this.items[this.editedIndex]
                if(item instanceof this.$db.Role) {
                    await item.delete().catch((error) => {
                        if(error?.response?.status === 403) {
                            this.showError(error?.response?.data?.error)
                        } else {
                            this.showError()
                        }
                    })
                } else {
                    console.warn('Here comes the headache...')
                    console.log('model', this.$db.Supplier)
                    console.log(item, this.editedIndex, item instanceof this.$db.Supplier)
                    const model = await this.$db.Supplier.find(item.id)
                    console.log(model, model.id)
                    await model.delete()
                }
                this.dialogDelete = false
                await this.initialize()
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            save () {
            },

            addNewItem: function() {
                this.$router.push({ name: 'admin-role-create' })
            },
            canDelete(item) {
                return this.protectedRoles.indexOf(item.id) < 0
            }
        },
    };
</script>
